/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import QuestionnairesQuestionnaireQuestionsAttributes from './QuestionnairesQuestionnaireQuestionsAttributes';

/**
 * The QuestionnairesQuestionnaire model module.
 * @module model/QuestionnairesQuestionnaire
 * @version v0.3
 */
export default class QuestionnairesQuestionnaire {
  /**
   * Constructs a new <code>QuestionnairesQuestionnaire</code>.
   * @alias module:model/QuestionnairesQuestionnaire
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>QuestionnairesQuestionnaire</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/QuestionnairesQuestionnaire} obj Optional instance to populate.
   * @return {module:model/QuestionnairesQuestionnaire} The populated <code>QuestionnairesQuestionnaire</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new QuestionnairesQuestionnaire();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('is_public'))
        obj.isPublic = ApiClient.convertToType(data['is_public'], 'Boolean');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('external_source'))
        obj.externalSource = ApiClient.convertToType(data['external_source'], 'String');
      if (data.hasOwnProperty('questions_attributes'))
        obj.questionsAttributes = ApiClient.convertToType(data['questions_attributes'], [QuestionnairesQuestionnaireQuestionsAttributes]);
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
    }
    return obj;
  }
}

/**
 * Title of the questionnaire
 * @member {String} title
 */
QuestionnairesQuestionnaire.prototype.title = undefined;

/**
 * Determines whether the survey can be accessed by a user who is not a Capable Health patient
 * @member {Boolean} isPublic
 * @default false
 */
QuestionnairesQuestionnaire.prototype.isPublic = false;

/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
QuestionnairesQuestionnaire.StatusEnum = {
  /**
   * value: "active"
   * @const
   */
  active: "active",

  /**
   * value: "archived"
   * @const
   */
  archived: "archived"
};
/**
 * @member {module:model/QuestionnairesQuestionnaire.StatusEnum} status
 * @default 'active'
 */
QuestionnairesQuestionnaire.prototype.status = 'active';

/**
 * @member {String} externalId
 */
QuestionnairesQuestionnaire.prototype.externalId = undefined;

/**
 * Allowed values for the <code>externalSource</code> property.
 * @enum {String}
 * @readonly
 */
QuestionnairesQuestionnaire.ExternalSourceEnum = {
  /**
   * value: "FormSort"
   * @const
   */
  formSort: "FormSort",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * @member {module:model/QuestionnairesQuestionnaire.ExternalSourceEnum} externalSource
 */
QuestionnairesQuestionnaire.prototype.externalSource = undefined;

/**
 * @member {Array.<module:model/QuestionnairesQuestionnaireQuestionsAttributes>} questionsAttributes
 */
QuestionnairesQuestionnaire.prototype.questionsAttributes = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
QuestionnairesQuestionnaire.prototype.tagList = undefined;

